import { FormItemController } from "./FormItemController";
import { HAFile } from "../../HTML/Form/Item/HAFile";
import { EditorFile } from "../../HTML/Editor/File";
import { FileContainer } from "../../HTML/Editor/FileContainer";
import { toMap } from "../../../../HA";

export class FileController extends FormItemController {

    public getValue() {
        const list = this.getTag().getSelected(), res = [];

        list.forEach( (item: any) => {
            if (item instanceof FileContainer) {
                res.push(item.getFile());
            } else {
                res.push(item);
            }
        });

        return res;
    }

    public isInputItem() {
        return true;
    }

    protected createItem() {
        const data = toMap({tag: this.getTag()});
        this.attachModalEntry(data, (cfg) => new EditorFile(cfg));
        return new HAFile(data);
    }

    protected replaceItems(items: any[]) {
        this.getTag().replaceItems(items);
    }

    protected getChoices() {
        return this.getTag().getChoices();
    }
}
